import { Settings, Styles } from 'react-chatbotify';

// Color constants for grey theme
const COLORS = {
  PRIMARY_DARK: '#343541',
  SECONDARY_BLUE: '#007a94',
  BORDER_GREY: '#5D5F67',
  MEDIUM_GREY: '#444654',
  LIGHT_GREY: '#EAEAEA',
  WHITE: '#FFFFFF',
  BACKGROUND_LIGHT: 'rgb(245 245 245)',
  SELECTION_DARK: '#40414F',
} as const;

export const GREY_THEME_SETTINGS: Settings = {
  general: {
    primaryColor: COLORS.PRIMARY_DARK,
    secondaryColor: COLORS.SECONDARY_BLUE,
    showFooter: true,
  },
};

export const GREY_THEME_STYLES: Styles = {
  chatWindowStyle: {
    backgroundColor: GREY_THEME_SETTINGS.general?.primaryColor ?? COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.5)',
    fontFamily: 'MBCorpoSText-Light',
  },
  headerStyle: {
    backgroundImage: `linear-gradient(to right, ${COLORS.SECONDARY_BLUE}, ${COLORS.PRIMARY_DARK})`,
  },
  chatInputContainerStyle: {
    backgroundColor: COLORS.BACKGROUND_LIGHT,
  },
  footerStyle: {
    backgroundImage: `linear-gradient(to left, ${COLORS.SECONDARY_BLUE}, ${COLORS.PRIMARY_DARK})`,
  },
  userBubbleStyle: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.MEDIUM_GREY,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  botBubbleStyle: {
    color: COLORS.LIGHT_GREY,
  },
  botOptionStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  botOptionHoveredStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.MEDIUM_GREY,
    borderRadius: 10,
    border: `2px solid ${COLORS.SECONDARY_BLUE}`,
    marginTop: 1,
    marginLeft: 1,
    boxShadow: 'inset 3px 3px 5px 3px rgba(0,0,0,0.1)',
  },
  botCheckboxRowStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  botCheckboxNextStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  botCheckMarkSelectedStyle: {
    color: COLORS.SECONDARY_BLUE,
    backgroundColor: COLORS.SELECTION_DARK,
  },
  chatHistoryButtonStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  chatHistoryButtonHoveredStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.MEDIUM_GREY,
    borderRadius: 10,
    borderColor: COLORS.SECONDARY_BLUE,
    border: '2px solid',
    marginTop: 1,
    marginLeft: 1,
    boxShadow: 'inset 3px 3px 5px 3px rgba(0,0,0,0.1)',
  },
  chatHistoryLineBreakStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.2)',
  },
  bodyStyle: {
    backgroundColor: COLORS.BACKGROUND_LIGHT,
  },
  loadingSpinnerStyle: {
    borderTop: `4px solid ${COLORS.SECONDARY_BLUE}`,
  },
  chatInputAreaStyle: {
    backgroundColor: COLORS.BACKGROUND_LIGHT,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
  },
  chatInputAreaFocusedStyle: {
    border: `2px solid ${COLORS.SECONDARY_BLUE}`,
    boxShadow: '0px 0px 5px 0px rgba(0,255,0,0.2)',
  },
  sendButtonStyle: {
    color: COLORS.LIGHT_GREY,
    backgroundColor: COLORS.PRIMARY_DARK,
    borderRadius: 10,
    border: `2px solid ${COLORS.SECONDARY_BLUE}`,
    boxShadow: '0px 0px 5px 0px rgba(0,255,0,0.2)',
  },
  sendButtonHoveredStyle: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.SECONDARY_BLUE,
    borderRadius: 10,
    border: `2px solid ${COLORS.BORDER_GREY}`,
    boxShadow: 'inset 3px 3px 5px 3px rgba(0,0,0,0.1)',
  },
  chatButtonStyle: {
    borderRadius: 40,
    backgroundImage: 'none',
  },
  tooltipStyle: {
    borderRadius: 10,
    backgroundColor: COLORS.SECONDARY_BLUE,
    color: COLORS.WHITE,
    right: '35px',
    bottom: '110px',
  },
  notificationIconStyle: {
    fill: 'white',
  },
};
